export const ENTITY_TYPE = {
    CAMPAIGN: 'CAMPAIGN',
    ADVERTISER: 'ADVERTISER',
};

export const PerformanceRulesActionType = {
    BLOCK_SITES: 'BLOCK_SITES',
    PAUSE_AD: 'PAUSE_AD',
    INCREASE_DAILY_BUDGET: 'INCREASE_DAILY_BUDGET',
    DECREASE_DAILY_BUDGET: 'DECREASE_DAILY_BUDGET',
};

export const PerformanceRuleDimension = { SITE_PER_CAMPAIGN: 'SITE_PER_CAMPAIGN', AD: 'AD', CAMPAIGN: 'CAMPAIGN' };
export const budgetActions = [
    PerformanceRulesActionType.INCREASE_DAILY_BUDGET,
    PerformanceRulesActionType.DECREASE_DAILY_BUDGET,
];

export const PerformanceRuleFrequencyType = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
};

export const PerformanceRuleFrequencyValues = {
    LOW: { hours: 12, type: PerformanceRuleFrequencyType.LOW },
    MEDIUM: { hours: 5, type: PerformanceRuleFrequencyType.MEDIUM },
    HIGH: { hours: 1, type: PerformanceRuleFrequencyType.HIGH },
};

export const PerformanceRuleMetricsWithNoTimeFrame = ['SITE_ID', 'SITE_NAME', 'BIDDING_STRATEGY'];

export const PerformanceRuleValueTypesWithTextValue = ['TEXT', 'TEXT_LIST', 'OPTIONS'];

export const MAX_PERFORMANCE_RULES_VALUE_LENGTH = 100;
